import axiosInstance from "../axiosInstance";

export const inventoryAnalysisService = {
  fetch: async ({
    clientId,
    tab,
    search,
    node,
    vendor,
    abcClass,
  } = {}) => {
    const params = {};
    if (clientId) params.client_id = clientId;
    if (tab) params.tab = tab;
    if (search) params.search = search;
    if (node) params.node = node;
    if (vendor) params.vendor = vendor;
    if (abcClass) params.abc_class = abcClass;

    const response = await axiosInstance.get("/inventory-analysis", {
      params,
      suppressErrorToast: true,
    });
    return response.data;
  },
};
